import EditorImagePicker from './editor-image-picker';

export default EditorImagePicker;
